// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

import App from './App'
import router from './router'

import AVPublicAPI from './api/AVPublicAPI'

Vue.use(Vuetify)
// Vue.config.productionTip = false

var api = new AVPublicAPI(process.env.API_URL)
Object.defineProperty(Vue.prototype, '$api', {
  get: () => api
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js